<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer5">
      <b-row>
        <b-col class="col-12">
          <b>
            <label>Important Questions</label>
          </b>
          <p>Please read and answer these important questions</p>
          <span class="add-info">
            <b>
              All lines marked with an asterisk (
              <font color="red">*</font>) are required.
            </b>
          </span>
          <hr/>
          <b-form-group
              label-cols-sm="5"
              :label="'1. Will you have other prescription drug coverage (like VA, TRICARE) in addition to ' + form.PlanName +' Plan ?'"
              label-for="otherhealthplan"
              label-class="font-weight-bold pt-0 custom-req"
              class="mb-1"
          >
            <validation-provider
                rules="required"
                :bails="false"
                v-slot="{ classes, errors }"
                class="col-3 p-0 mr-1"
                vid="otherhealthplan"
                name="selection"
            >
              <div class="control" :class="classes">
                <b-form-radio-group
                    id="otherhealthplan"
                    class="pt-2"
                    :options="[{text:'Yes',value:'Y'},{text:'No', value:'N'}]"
                    ref="otherhealthplan"
                    v-model="form.otherhealthplan"
                    @change="removeDetails(form.otherhealthplan,['othercoveragename','othercoverageid','othercoveragegroup'])"
                ></b-form-radio-group>
                <span>{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-form-group>
          <span v-if="form.otherhealthplan === 'Y'">
            <P>If "yes", please list your other coverage and your identification (ID) number(s) for this coverage:</P>
            <b-form-group
                label-cols-sm="5"
                label="Name of other coverage"
                label-for="othercoveragename"
                class="mb-0"
            >
              <validation-provider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes, errors }"
                  class="col-3 p-0 mr-1"
                  vid="othercoveragename"
                  name="Name of other coverage"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="othercoveragename"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      placeholder="Enter Name here"
                      v-model="form.othercoveragename"
                      ref="othercoveragename"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Member number for this coverage"
                label-for="othercoverageid"
                class="mb-0"
            >
              <validation-provider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes, errors }"
                  class="col-3 p-0 mr-1"
                  vid="othercoverageid"
                  name="Member number for this coverage"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="othercoverageid"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      placeholder="Member number for this coverage"
                      v-model="form.othercoverageid"
                      ref="othercoverageid"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-form-group>
            <b-form-group
                label-cols-sm="5"
                label="Group number for this coverage"
                label-for="othercoveragegroup"
                class="mb-0"
            >
              <validation-provider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes, errors }"
                  class="col-3 p-0 mr-1"
                  vid="othercoveragegroup"
                  name="Group for this coverage"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="othercoveragegroup"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      placeholder="Group number for this coverage"
                      v-model="form.othercoveragegroup"
                      ref="othercoveragegroup"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-form-group>
          </span>
          <b-form-group
              label-cols-sm="5"
              label="2. Are you enrolled in your State Medicaid program? "
              label-for="statemedicaid"
              label-class="font-weight-bold pt-0 custom-req"
              class="mb-2"
          >
            <validation-provider
                rules="required"
                :bails="false"
                v-slot="{ classes, errors }"
                class="col-3 p-0 mr-1"
                vid="statemedicaid"
                name="selection"
            >
              <div class="control" :class="classes">
                <b-form-radio-group
                    id="statemedicaid"
                    class="pt-2"
                    :options="[{value:'Y',text:'Yes'},{value:'N', text:'No'}]"
                    v-model="form.statemedicaid"
                    ref="statemedicaid"
                    @change="removeDetails(form.statemedicaid,['medicaidnumber'])"
                ></b-form-radio-group>
                <span>{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-form-group>
          <span v-if="form.statemedicaid==='Y'">
            <b-form-group
                label-cols-sm="5"
                label="If yes, please provide your Medicaid number"
                label-for="medicaidnumber"
                class="mb-2"
            >
              <validation-provider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes, errors }"
                  class="col-3 p-0 mr-1"
                  vid="medicaidnumber"
                  name="Medicaid Number"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      id="medicaidnumber"
                      class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      placeholder="Enter Medicaid Number"
                      ref="medicaidnumber"
                      v-model="form.medicaidnumber"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-form-group>
          </span>
          <p class="mb-0">
            <b>Answering these questions is your choice. You can’t be denied coverage because you don’t fill them
              out.</b>
          </p>
          <b-form-group
              label-cols-sm="5"
              label="Select one if you want us to send you information in a language other than English."
              label-for="infoPreferenceLang"
              label-class="font-weight-bold pt-0"
              class="mb-2"
          >
<!--            <b-form-radio-group-->
<!--                v-model="form.infoPreference"-->
<!--                id="infoPreferenceLang"-->
<!--                class="pt-2"-->
<!--                :options="langCodes"-->
<!--            ></b-form-radio-group>-->
            <b-form-select id="relationship" ref="relationship" class="col-2" v-model="form.infoPreference"
                           :options="langCodes" size="sm" placeholder="Select"></b-form-select>
          </b-form-group>
          <b-form-group
              label-cols-sm="5"
              label="Select one if you want us to send you information in an accessible format."
              label-for="infoPreferenceFormat"
              label-class="font-weight-bold pt-0"
              class="mb-2"
          >
            <b-form-radio-group
                v-model="form.infoPreferenceFormat"
                id="infoPreferenceFormat"
                class="pt-2"
                :options="[{value:'BRAILLE',text: 'Braille'},{value:'LP',text:'Large Print'}]"
            ></b-form-radio-group>
          </b-form-group>
          <br/>
          <p v-if="form.PayerPhoneNumber">Please contact {{ form.PlanName }} Plan at {{ form.PayerPhoneNumber  | VMask('(###)-###-####')}} (TTY:
            {{ form.PayerPhoneNumberExtension }}) toll-free if you need information in an accessible format or language
            other than what is listed above. Our office hours are 8.00 a.m. to 8.00 p.m. Monday through Friday and daily
            during the enrollment/disenrollment periods.</p>
          <p>
            <b>Typically, you may enroll in a Medicare Advantage plan only during the annual enrollment period from
              October 15 through December 7 of each year.</b> There are exceptions that may allow you to enroll in a
            Medicare Advantage plan outside of this period. If you are applying for a Special Election Period (SEP),
            please select one of the options on the following page.
          </p>
          <b-form-group
              label-cols-sm="5"
              label="Do you work ? "
              label-for="EmploymentStatus"
              label-class="font-weight-bold pt-0"
              class="mb-2"
          >
            <div class="control">
              <b-form-radio-group
                  id="EmploymentStatus"
                  class="pt-2"
                  :options="[{value:'Y',text:'Yes'},{value:'N',text: 'No'}]"
                  ref="EmploymentStatus"
                  v-model="form.EmploymentStatus"
              ></b-form-radio-group>
            </div>
          </b-form-group>
          <b-form-group
              label-cols-sm="5"
              label="Does your spouse work ? "
              label-for="SpouseEmploymentStatus"
              label-class="font-weight-bold pt-0"
              class="mb-2"
          >
            <div class="control">
              <b-form-radio-group
                  id="SpouseEmploymentStatus"
                  class="pt-2"
                  :options="[{value:'Y',text:'Yes'},{value:'N',text: 'No'}]"
                  ref="SpouseEmploymentStatus"
                  v-model="form.SpouseEmploymentStatus"
              ></b-form-radio-group>
            </div>
          </b-form-group>

          <p>
            <b>Please choose the name of a Primary Care Physician (PCP) and Medical Group/IPA: (optional)</b>
          </p>
          <div :key="pcpcomponent">
          <b-form-group
              label-cols-sm="2"
              label="Primary Care Physician "
              label-for="pcp"
              class="mb-2"
              label-class="font-weight-bold custom-req"
          >
            <b-input-group class="mb-1" id="name">
              <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-sm-3 col-xs-12 p-0 pr-1"
                      vid="PCPFirstName"
                      name="First Name"
              >
                <div class="control" :class="classes">
                  <b-form-input
                      type="text"
                      id="PCPFirstName"
                      placeholder="First Name"
                      v-model="form.PCPFirstName"
                      ref="PCPFirstName"
                      class="customSmallInputGap"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-sm-3 col-xs-12 p-0 pr-1 pr-sm-2"
                      vid="PCPLastName"
                      name="Last Name"
              >
                <div class="control" :class="classes">
                  <b-form-input
                          id="PCPLastName"
                          placeholder="Last Name"
                          v-model="form.PCPLastName"
                          ref="lname"
                          class="customSmallInputGap"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <div class="control col-sm-3 col-xs-12 p-0 pr-1">
                <b-form-input
                    id="nested-pcpinitial"
                    placeholder="Middle Name"
                    style="margin-right:3px"
                    v-model="form.PCPMiddleName"
                    class="customSmallInputGap"
                    ref="mname"
                ></b-form-input>
              </div>
              <span class="font-weight-bold">
                 <b-button size="sm" class="mt-1" title="Search PCP" @click="showModal('pcpserach')">
                   <b-icon-search icon="search"></b-icon-search> Search
                 </b-button>
                </span>
            </b-input-group>
          </b-form-group>
          <b-form-group
              label-cols-sm="2"
              label="Medical Group/IPA "
              label-for="medicalGrp"
              class="mb-2"
              label-class="font-weight-bold custom-req"
          >
            <validation-provider
                    rules="required"
                    :bails="false"
                    v-slot="{ classes, errors }"
                    vid="medicalGrp"
                    name="Medical Group/IPA"
            >
              <div class="control col-sm-3 col-xs-12 p-0 pr-2" :class="classes">
                <b-form-input
                        id="medicalGrp"
                        placeholder="Medical Group/IPA"
                        v-model="form.IPAName"
                ></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-form-group>
          <b-form-group
              label-cols-sm="2"
              label="PCP ID "
              label-for="PCPID"
              class="mb-2"
              label-class="font-weight-bold custom-req"
          >
            <div class="control col-12 p-0">
              <b-row>
                <b-col class="col-12 col-sm-3 pr-4 pr-sm-0">
                  <validation-provider
                          rules="required"
                          :bails="false"
                          v-slot="{ classes, errors }"
                          vid="pcpid"
                          name="PCP ID"
                  >
                    <div class="control" :class="classes">
                      <b-form-input
                              id="pcpid"
                              placeholder="PCP ID"
                              v-model="form.PCPID"
                      ></b-form-input>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </b-col>
                <b-col class="col-12 col-sm-3 col-md-3 col-lg-2 text-left text-sm-right">
                  <label class="font-weight-bolder mt-2">Existing patient ? </label>
                </b-col>
                <b-col class="col-12 col-sm-3 col-md-3 col-lg-2">
                  <b-form-radio-group class="pt-2" :options="{Y:'Yes',N: 'No'}"
                                      v-model="form.PCPExistingMember"></b-form-radio-group>
                </b-col>
              </b-row>
            </div>
          </b-form-group>
          </div>
          <hr/>
          <b-form-group
              label-cols-sm="2"
              label="Emergency Contact "
              label-for="emerContact"
              label-class="font-weight-bold pt-0 text-left"
              class="mb-2"
          >
            <div class="control col-sm-3 col-xs-12 p-0 pr-2">
              <b-form-input id="emerContact" v-model="form.emerContact" placeholder="Emergency Contact"></b-form-input>
            </div>
          </b-form-group>
          <b-form-group
              label-cols-sm="2"
              label="Relationship"
              label-for="relationship"
              label-class="font-weight-bold pt-0 text-left"
              class="mb-2"
          >
            <div class="control col-sm-3 col-xs-12 p-0 pr-2">
              <b-form-select id="relationship" ref="relationship" v-model="form.emerContactRelationship"
                             :options="relncodes" size="sm" placeholder="Relationship"></b-form-select>
            </div>
          </b-form-group>
          <b-form-group
              label-cols-sm="2"
              label="Phone Number"
              label-for="emerContPh"
              label-class="font-weight-bold pt-0 text-left"
              class="mb-2"
          >
            <ValidationProvider
                rules="min-phnum"
                v-slot="{ classes, errors }"
                name="Phone Number  "
                class="col-3 p-0"
                vid="emerContPh"
            >
              <div class="control col-sm-3 col-xs-12 p-0 pr-2" :class="classes">
                <b-form-input
                    id="emerContPh"
                    v-model="form.emerContactPhone"
                    v-mask="'(###)-###-####'"
                    placeholder="Phone Number"
                    ref="emerContPh"
                ></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
              label-cols-sm="2"
              label="Email Address "
              label-for="emerContactEmail"
              label-class="font-weight-bold pt-0 text-left"
              class="mb-2"
          >
            <ValidationProvider
                rules="email"
                v-slot="{ classes, errors }"
                name="Email"
                class="col-3 p-0"
                vid="emerContactEmail"
            >
              <div class="control col-sm-3 col-xs-12 p-0 pr-2" :class="classes">
                <b-form-input id="emerContactEmail" v-model="form.emerContactEmail" placeholder="Email"></b-form-input>
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>
          <hr/>
          <b-modal size="xl" ref="pcpserach" title="Search Primary Care Physicians" hide-footer scrollable>
<!--            <div class="d-block text-center">-->
<!--              <b-input-group size="sm" class="mb-2">-->
<!--                <b-input-group-prepend is-text>-->
<!--                  <b-icon-search icon="search"></b-icon-search>-->
<!--                </b-input-group-prepend>-->
<!--                <b-form-input type="search" v-model="pcpsearchval" placeholder="Search PCP"-->
<!--                              @input="searchPCPs(pcpsearchval)"></b-form-input>-->
<!--              </b-input-group>-->
<!--              <div>-->
<!--                <b-table striped hover :items="pcpList" :fields="fields" sort-icon-left @row-clicked="choosePCP($event,'pcpserach')" row-title="Select this" ></b-table>-->
<!--              </div>-->
<!--            </div>-->
            <ProviderSearchComponent :modal-popup="true" @providerselected="choosePCP($event,'pcpserach')"></ProviderSearchComponent>
          </b-modal>


        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";
import {BIconSearch} from 'bootstrap-vue'
import MedicareLeadsService from "@/MedicareLeadsService";
import ProviderSearchComponent from "@/components/ProviderSearchComponent";

export default {
  name: "ImportantQuestion",
  components: {
    BIconSearch,
    ProviderSearchComponent
  },
  data() {
    return {
      pcpsearchval: "",
      pcpcomponent: 0,
      fields: [{key: 'iPA_name', label: 'IPA Name',class: 'text-left custTableCol'}, {key: 'pcp_id', label: 'PCP ID',class: 'text-left hideXS custTableCol'}, {
        key: 'first_name',
        label: 'First Name',class: 'text-left custTableCol'
      },{key: 'last_name', label: 'Last Name',class: 'text-left custTableCol'}, {key: 'middle_name', label: 'Middle Name',class: 'text-left hideXS custTableCol'}],
      pcpList: [],
      langCodes: []
    };
  },
  props: {
    form: Object,
    relncodes: Array
  },
  methods: {
    removeDetails: function (checkVal, remArr) {
      if (checkVal === "Y") {
        remArr.forEach(item => {
          delete this.form[item];
        });
      }
    },
    showModal(mod) {
      this.$refs[mod].show()
    },
    hideModal(mod) {
      this.$refs[mod].hide()
    },
    choosePCP(evnt,mod) {
      console.log("row clicked event :::: ",evnt)
      this.form.PCPID = evnt.ProviderID;
      this.form.PCPIPAID = evnt.PCPIPAID;
      this.form.PCPFirstName = evnt.ProviderFirstName;
      this.form.PCPLastName = evnt.ProviderLastName;
      this.form.PCPMiddleName = evnt.ProviderMiddleName;
      this.form.IPAName = evnt.IPAName;
      this.form.IPAKey = evnt.IPAKey;
      this.pcpcomponent += 1;
      this.$refs[mod].hide()
    },
    async searchPCPs(val) {
      if (val && val.length > 2) {
        this.pcpList = [];
        this.pcpList = await MedicareLeadsService.getPcps(val);
      } else {
        this.pcpList = [];
      }
    }
  },
  async created() {
    this.langCodes = [];
    if(process.env.VUE_APP_LANG){
      let langVal = process.env.VUE_APP_LANG;
      let langValArr = langVal ? langVal.split(",") : [];
      let langs = await MedicareLeadsService.getLangCodes(langValArr);
      for (let i of langs) {
        let codeItem = {"value": i.Code, text: i.CodeName};
        this.langCodes.push(codeItem);
      }
    }else{
      let langs = await MedicareLeadsService.getCodes('LANG');
      for (let i of langs) {
        let codeItem = {"value": i.Code, text: i.CodeName};
        this.langCodes.push(codeItem);
      }
    }
  }
};
</script>
<style>
  .custTableCol{
    cursor: pointer !important;
  }
</style>
